window.SmartSnippets = {
  load(selector) {
    return jQuery(selector).each(function () {
      const snippetType = jQuery(this).attr("data-type");
      const snippetParams = jQuery(this).attr("data-params");
      return jQuery.get(`/snippets/${snippetType}`, { params: snippetParams }, (data) =>
        jQuery(this).replaceWith(data),
      );
    });
  },
};

// INITIALIZE
$(() => SmartSnippets.load("[data-behavior~=snippet]"));
